import React, { PropsWithChildren, useEffect, useState } from 'react';

import './popup-content.scss';

interface PopupContentItemProps {
  hash: string
  content: React.ReactNode
  closeHref?: string
}

type PopupContentProps = PropsWithChildren<{}>;
type ComponentWithName<T> = React.FC<T> & { componentName: string };
type PopupContentItemElement = React.ReactElement<PopupContentItemProps, ComponentWithName<PopupContentItemProps>>;

const PopupContent: React.FC<PopupContentProps> = (props: PopupContentProps) => {

  const [ hash, setHash ] = useState<string>(window.location.hash);

  useEffect(() => {
    const onChange = () => {
      setHash(window.location.hash);
    };

    window.addEventListener('hashchange', onChange);

    return () => {
      window.removeEventListener('hashchange', onChange);
    }
  }, []);

  const children = React.Children.toArray(props.children).filter((child: React.ReactNode) => {
    return (React.isValidElement<ComponentWithName<unknown>>(child)) && ((child.type as ComponentWithName<unknown>).componentName === 'PopupContentItem');
  }) as PopupContentItemElement[];

  const child = children.find((child: PopupContentItemElement) => {
    return (child.props.hash === hash.replace('#', ''));
  });

  const hasChild = (child !== undefined);

  useEffect(() => {
    document.body.style.overflow = hasChild ? 'hidden' : 'unset';
  }, [ hasChild ]);

  if (!hasChild) {
    return <React.Fragment />;
  }

  const closeHref = child.props.closeHref || '#home';

  return (
    <div className="component-popup-content">
      <div className="close">
        <a href={closeHref}><i className="bi bi-x-lg"></i>Close</a>
      </div>
      <div className="content">
        {child}
      </div>
    </div>
  );
};

const PopupContentItem: ComponentWithName<PopupContentItemProps> = (props: PopupContentItemProps) => {
  return (
    <div className={`component-popup-content-item`}>
      {props.content}
    </div>
  );
}

PopupContentItem.componentName = 'PopupContentItem';

export { PopupContentItem };
export default PopupContent;